export const CURRENCY_CODE_OPTIONS = [
  { text: 'Unknown', value: '-' },
  { text: 'Arcblock', value: 'ABT' },
  { text: 'Cardano', value: 'ADA' },
  { text: 'Andorran franc (1:1 peg to the French franc)', value: 'ADF' },
  { text: 'Aidos Kuneen', value: 'ADK' },
  { text: 'ADP', value: 'ADP' },
  { text: 'Aeternity', value: 'AE' },
  { text: 'United Arab Emirates Dirham', value: 'AED' },
  { text: 'Afghan afghani', value: 'AFN' },
  { text: 'Aion', value: 'AION' },
  { text: 'Algorand', value: 'ALGO' },
  { text: 'Lek', value: 'ALL' },
  { text: 'Dram', value: 'AMD' },
  { text: 'Netherlands Antilles Guilder', value: 'ANG' },
  { text: 'Aragon', value: 'ANT' },
  { text: 'Angolan kwanza', value: 'AOA' },
  { text: 'Kwanza', value: 'AOK' },
  { text: 'AON', value: 'AON' },
  { text: 'ARA', value: 'ARA' },
  { text: 'Ardor', value: 'ARDR' },
  { text: 'Ark', value: 'ARK' },
  { text: 'Argentinean Nuevo Peso', value: 'ARS' },
  { text: 'ATS', value: 'ATS' },
  { text: 'Australian Dollar', value: 'AUD' },
  { text: 'Aruban Guilder', value: 'AWG' },
  { text: 'Azerbaijani manat', value: 'AZN' },
  { text: 'Convertible Mark', value: 'BAM' },
  { text: 'Basic Attention Token', value: 'BAT' },
  { text: 'Barbados Dollar', value: 'BBD' },
  { text: 'Bitcoin Diamond', value: 'BCD' },
  { text: 'Bitcoin Cash', value: 'BCH' },
  { text: 'Bytecoin', value: 'BCN' },
  { text: 'Taka', value: 'BDT' },
  { text: 'Beam', value: 'BEAM' },
  { text: 'Convertible Belgian Franc (no longer in use)', value: 'BEC' },
  { text: 'BEF', value: 'BEF' },
  { text: 'Financial Belgian Franc (no longer in use)', value: 'BEL' },
  { text: 'BGL', value: 'BGL' },
  { text: 'Bulgarian lev', value: 'BGN' },
  { text: 'Bahraini Dinar', value: 'BHD' },
  { text: 'BHPCoin', value: 'BHP' },
  { text: 'Burundi Franc', value: 'BIF' },
  { text: 'Bibox Token', value: 'BIX' },
  { text: 'Bermudian Dollar', value: 'BMD' },
  { text: 'Binance Coin', value: 'BNB' },
  { text: 'Brunei Dollar', value: 'BND' },
  { text: 'Bancor', value: 'BNT' },
  { text: 'BOSAGORA', value: 'BOA' },
  { text: 'Boliviano', value: 'BOB' },
  { text: 'Bread', value: 'BRD' },
  { text: 'Real', value: 'BRL' },
  { text: 'Bahamian Dollar', value: 'BSD' },
  { text: 'BlockStamp', value: 'BST' },
  { text: 'Bitcoin SV', value: 'BSV' },
  { text: 'Bitcoin', value: 'BTC' },
  { text: 'Bitcoin Gold', value: 'BTG' },
  { text: 'Bytom', value: 'BTM' },
  { text: 'Ngultrum', value: 'BTN' },
  { text: 'BitShares', value: 'BTS' },
  { text: 'BitTorrent', value: 'BTT' },
  { text: 'Replaced by MMK', value: 'BUK' },
  { text: 'Binance USD', value: 'BUSD' },
  { text: 'Pula', value: 'BWP' },
  { text: 'Belarussian Rouble', value: 'BYR' },
  { text: 'Belize Dollar', value: 'BZD' },
  { text: 'Canadian Dollar', value: 'CAD' },
  { text: 'Congolese franc', value: 'CDF' },
  { text: 'New Zaïre', value: 'CDZ' },
  { text: 'Centrality', value: 'CENNZ' },
  { text: 'WIR Bank (complementary currency)', value: 'CHE' },
  { text: 'Swiss Franc', value: 'CHF' },
  { text: 'SwissBorg', value: 'CHSB' },
  { text: 'Chiliz', value: 'CHZ' },
  { text: 'Nervos Network', value: 'CKB' },
  { text: 'Unidades de Fomento', value: 'CLF' },
  { text: 'Chilean Peso', value: 'CLP' },
  { text: 'Yuan Renminbi', value: 'CNY' },
  { text: 'Colombian Peso', value: 'COP' },
  { text: 'Unidad de Valor Real', value: 'COU' },
  { text: 'Costa Rican Colón', value: 'CRC' },
  { text: 'Crypto.com Coin', value: 'CRO' },
  { text: 'Crypterium', value: 'CRPT' },
  { text: 'CSK', value: 'CSK' },
  { text: 'Cuban Peso', value: 'CUP' },
  { text: 'Civic', value: 'CVC' },
  { text: 'Escudo Caboverdiano', value: 'CVE' },
  { text: 'CYP', value: 'CYP' },
  { text: 'Czech Koruna', value: 'CZK' },
  { text: 'Multi-collateral DAI', value: 'DAI' },
  { text: 'Dash', value: 'DASH' },
  { text: 'Dentacoin', value: 'DCN' },
  { text: 'Decred', value: 'DCR' },
  { text: 'DDM', value: 'DDM' },
  { text: 'DEM', value: 'DEM' },
  { text: 'Dent', value: 'DENT' },
  { text: 'DigiByte', value: 'DGB' },
  { text: 'DigixDAO', value: 'DGD' },
  { text: 'Digitex Futures', value: 'DGTX' },
  { text: 'Divi', value: 'DIVI' },
  { text: 'Djibouti Franc', value: 'DJF' },
  { text: 'Danish Krone', value: 'DKK' },
  { text: 'DMarket', value: 'DMT' },
  { text: 'Dogecoin', value: 'DOGE' },
  { text: 'Dominican Republic Peso', value: 'DOP' },
  { text: 'Diamond Platform Token', value: 'DPT' },
  { text: 'Dragon Coins', value: 'DRG' },
  { text: 'DxChain Token', value: 'DX' },
  { text: 'Algerian Dinar', value: 'DZD' },
  { text: 'ECS', value: 'ECS' },
  { text: 'ECV', value: 'ECV' },
  { text: 'EDC Blockchain', value: 'EDC' },
  { text: 'Kroon', value: 'EEK' },
  { text: 'Egyptian Pound', value: 'EGP' },
  { text: 'EDUCare', value: 'EKT' },
  { text: 'Elastos', value: 'ELA' },
  { text: 'aelf', value: 'ELF' },
  { text: 'Enigma', value: 'ENG' },
  { text: 'Enjin Coin', value: 'ENJ' },
  { text: 'EOS', value: 'EOS' },
  { text: 'Elrond', value: 'ERD' },
  { text: 'Eritrean Nakfa', value: 'ERN' },
  { text: 'ESA', value: 'ESA' },
  { text: 'ESB', value: 'ESB' },
  { text: 'ESP', value: 'ESP' },
  { text: 'Ethiopian Birr', value: 'ETB' },
  { text: 'Ethereum Classic', value: 'ETC' },
  { text: 'Ethereum', value: 'ETH' },
  { text: 'Electroneum', value: 'ETN' },
  { text: 'Metaverse ETP', value: 'ETP' },
  { text: 'Euro (replacement name for the ECU)', value: 'EUR' },
  { text: 'STASIS EURO', value: 'EURS' },
  { text: 'Factom', value: 'FCT' },
  { text: 'Fetch.ai', value: 'FET' },
  { text: 'FIM', value: 'FIM' },
  { text: 'Fiji Dollar', value: 'FJD' },
  { text: 'Falkland Pound', value: 'FKP' },
  { text: 'FRF', value: 'FRF' },
  { text: 'Fantom', value: 'FTM' },
  { text: 'FTX Token', value: 'FTT' },
  { text: 'FunFair', value: 'FUN' },
  { text: 'Pound Sterling (United Kingdom Pound)', value: 'GBP' },
  { text: 'Lari', value: 'GEL' },
  { text: 'GHC', value: 'GHC' },
  { text: 'Ghanaian cedi', value: 'GHS' },
  { text: 'Gibraltar Pound', value: 'GIP' },
  { text: 'Dalasi', value: 'GMD' },
  { text: 'Guinean franc', value: 'GNF' },
  { text: 'Gnosis', value: 'GNO' },
  { text: 'Syli (also known as Guinea Franc)', value: 'GNS' },
  { text: 'Golem', value: 'GNT' },
  { text: 'GoChain', value: 'GO' },
  { text: 'GQE', value: 'GQE' },
  { text: 'GRD', value: 'GRD' },
  { text: 'Grin', value: 'GRIN' },
  { text: 'Groestlcoin PYG Guarani', value: 'GRS' },
  { text: 'Gatechain Token', value: 'GT' },
  { text: 'Quetzal', value: 'GTQ' },
  { text: 'GWP', value: 'GWP' },
  { text: 'GXChain', value: 'GXC' },
  { text: 'Guyana Dollar', value: 'GYD' },
  { text: 'Hedera Hashgraph', value: 'HBAR' },
  { text: 'HyperCash', value: 'HC' },
  { text: 'HedgeTrade', value: 'HEDG' },
  { text: 'Hong Kong Dollar', value: 'HKD' },
  { text: 'Lempira', value: 'HNL' },
  { text: 'Holo', value: 'HOT' },
  { text: 'Huobi Pool Token', value: 'HPT' },
  { text: 'Croatian Kuna', value: 'HRK' },
  { text: 'Huobi Token', value: 'HT' },
  { text: 'Gourde', value: 'HTG' },
  { text: 'Forint', value: 'HUF' },
  { text: 'Hyperion', value: 'HYN' },
  { text: 'ICON', value: 'ICX' },
  { text: 'Rupiah', value: 'IDR' },
  { text: 'IEP', value: 'IEP' },
  { text: 'Ignis', value: 'IGNIS' },
  { text: 'ILCoin', value: 'ILC' },
  { text: 'ILP', value: 'ILP' },
  { text: 'ILR', value: 'ILR' },
  { text: 'Shekel', value: 'ILS' },
  { text: 'Indian Rupee', value: 'INR' },
  { text: 'IOST', value: 'IOST' },
  { text: 'IoTeX', value: 'IOTX' },
  { text: 'Iraqi Dinar', value: 'IQD' },
  { text: 'Iranian Rial', value: 'IRR' },
  { text: 'ISJ', value: 'ISJ' },
  { text: 'Icelandic Króna', value: 'ISK' },
  { text: 'ITL', value: 'ITL' },
  { text: 'Jamaican Dollar', value: 'JMD' },
  { text: 'Jordanian Dinar', value: 'JOD' },
  { text: 'Yen', value: 'JPY' },
  { text: 'BitKan', value: 'KAN' },
  { text: 'KuCoin Shares', value: 'KCS' },
  { text: 'Kenyan Shilling', value: 'KES' },
  { text: 'Kyrgyzstani Som', value: 'KGS' },
  { text: 'Riel', value: 'KHR' },
  { text: 'KickToken', value: 'KICK' },
  { text: 'Komodo', value: 'KMD' },
  { text: 'Comorian Franc', value: 'KMF' },
  { text: 'Kyber Network', value: 'KNC' },
  { text: "Democratic People's Republic of Korean Won", value: 'KPW' },
  { text: 'Republic of Korean Won', value: 'KRW' },
  { text: 'Kuwaiti Dinar', value: 'KWD' },
  { text: 'Cayman Islands Dollar', value: 'KYD' },
  { text: 'Tenge', value: 'KZT' },
  { text: 'LAJ', value: 'LAJ' },
  { text: 'Kip', value: 'LAK' },
  { text: 'Lambda', value: 'LAMB' },
  { text: 'Cred', value: 'LBA' },
  { text: 'Lebanese Pound', value: 'LBP' },
  { text: 'Lightning Bitcoin', value: 'LBTC' },
  { text: 'Aave', value: 'LEND' },
  { text: 'UNUS SED LEO', value: 'LEO' },
  { text: 'Chainlink', value: 'LINK' },
  { text: 'Sri Lankan Rupee', value: 'LKR' },
  { text: 'Loki', value: 'LOKI' },
  { text: 'Loom Network', value: 'LOOM' },
  { text: 'Loopring', value: 'LRC' },
  { text: 'Liberian Dollar', value: 'LRD' },
  { text: 'Lisk', value: 'LSK' },
  { text: 'Loti', value: 'LSL' },
  { text: 'Maloti', value: 'LSM' },
  { text: 'Litecoin', value: 'LTC' },
  { text: 'Litas', value: 'LTL' },
  { text: 'LUF', value: 'LUF' },
  { text: 'Terra', value: 'LUNA' },
  { text: 'Lats', value: 'LVL' },
  { text: 'Libyan Dinar', value: 'LYD' },
  { text: 'Moroccan Dirham', value: 'MAD' },
  { text: 'MAF', value: 'MAF' },
  { text: 'MaidSafeCoin', value: 'MAID' },
  { text: 'Decentraland', value: 'MANA' },
  { text: 'Matic Network', value: 'MATIC' },
  { text: 'MCF', value: 'MCF' },
  { text: 'MCO', value: 'MCO' },
  { text: 'Moeda Loyalty Points', value: 'MDA' },
  { text: 'Moldavian Leu', value: 'MDL' },
  { text: 'MediBloc [ERC20]', value: 'MEDX' },
  { text: 'Malagasy ariary', value: 'MGA' },
  { text: 'IOTA', value: 'MIOTA' },
  { text: 'Macedonian Dinar', value: 'MKD' },
  { text: 'MKN', value: 'MKN' },
  { text: 'Maker', value: 'MKR' },
  { text: 'MLF', value: 'MLF' },
  { text: 'Kyat', value: 'MMK' },
  { text: 'Tugrik', value: 'MNT' },
  { text: 'Molecular Future', value: 'MOF' },
  { text: 'MonaCoin', value: 'MONA' },
  { text: 'Pataca', value: 'MOP' },
  { text: 'Ouguiya', value: 'MRO' },
  { text: 'Metal', value: 'MTL' },
  { text: 'Maltese Pound, replaced by Maltese Lira', value: 'MTP' },
  { text: 'Mauritius Rupee', value: 'MUR' },
  { text: 'MVQ', value: 'MVQ' },
  { text: 'Rufiyaa', value: 'MVR' },
  { text: 'Malawian Kwacha', value: 'MWK' },
  { text: 'MX Token', value: 'MX' },
  { text: 'Mexican New Peso (replacement for Mexican Peso)', value: 'MXN' },
  { text: 'Ringgit (also known as Malaysian Dollar)', value: 'MYR' },
  { text: 'MZM', value: 'MZM' },
  { text: 'Mozambican metical', value: 'MZN' },
  { text: 'Namibian Dollar', value: 'NAD' },
  { text: 'Nano', value: 'NANO' },
  { text: 'Nebulas', value: 'NAS' },
  { text: 'Neo', value: 'NEO' },
  { text: 'Newton', value: 'NEW' },
  { text: 'Nash Exchange', value: 'NEX' },
  { text: 'Nexo', value: 'NEXO' },
  { text: 'NFD', value: 'NFD' },
  { text: 'Naira', value: 'NGN' },
  { text: 'Cordoba oro', value: 'NIO' },
  { text: 'NLG', value: 'NLG' },
  { text: 'Numeraire', value: 'NMR' },
  { text: 'Norwegian Krone', value: 'NOK' },
  { text: 'Nepalese Rupee', value: 'NPR' },
  { text: 'Pundi X', value: 'NPXS' },
  { text: 'Energi', value: 'NRG' },
  { text: 'NULS', value: 'NULS' },
  { text: 'New Zealand Dollar', value: 'NZD' },
  { text: 'Ocean Protocol', value: 'OCEAN' },
  { text: 'OKB', value: 'OKB' },
  { text: 'OmiseGO', value: 'OMG' },
  { text: 'Omani Rial', value: 'OMR' },
  { text: 'Harmony', value: 'ONE' },
  { text: 'Ontology', value: 'ONT' },
  { text: 'Orbs', value: 'ORBS' },
  { text: 'Balboa', value: 'PAB' },
  { text: 'Project Pai', value: 'PAI' },
  { text: 'Paxos Standard', value: 'PAX' },
  { text: 'PEH', value: 'PEH' },
  { text: 'PEI', value: 'PEI' },
  { text: 'New Sol', value: 'PEN' },
  { text: 'Sol (replaced by New Sol [PEN])', value: 'PES' },
  { text: 'Kina', value: 'PGK' },
  { text: 'Philippines Peso', value: 'PHP' },
  { text: 'PIVX', value: 'PIVX' },
  { text: 'Pakistani Rupee', value: 'PKR' },
  { text: 'Polybius', value: 'PLBT' },
  { text: 'New Zloty', value: 'PLN' },
  { text: 'PLZ', value: 'PLZ' },
  { text: 'Power Ledger', value: 'POWR' },
  { text: 'Populous', value: 'PPT' },
  { text: 'PTE', value: 'PTE' },
  { text: 'PYG', value: 'PYG' },
  { text: 'Qatari Riyal', value: 'QAR' },
  { text: 'QASH', value: 'QASH' },
  { text: 'Quant', value: 'QNT' },
  { text: 'Qtum', value: 'QTUM' },
  { text: 'Revain', value: 'R' },
  { text: 'Ripio Credit Network', value: 'RCN' },
  { text: 'ReddCoin', value: 'RDD' },
  { text: 'Ren', value: 'REN' },
  { text: 'Augur', value: 'REP' },
  { text: 'RIF Token', value: 'RIF' },
  { text: 'iExec RLC', value: 'RLC' },
  { text: 'ROL', value: 'ROL' },
  { text: 'Romanian new leu', value: 'RON' },
  { text: 'Robotina', value: 'ROX' },
  { text: 'Serbian dinar', value: 'RSD' },
  { text: 'Russian Federation Rouble (formerly RUR)', value: 'RUB' },
  { text: 'THORChain', value: 'RUNE' },
  { text: 'RUR', value: 'RUR' },
  { text: 'Ravencoin', value: 'RVN' },
  { text: 'Rwandan Franc', value: 'RWF' },
  { text: 'Single Collateral DAI', value: 'SAI' },
  { text: 'Santiment Network Token', value: 'SAN' },
  { text: 'Saudi Riyal', value: 'SAR' },
  { text: 'Solomon Islands Dollar', value: 'SBD' },
  { text: 'Siacoin', value: 'SC' },
  { text: 'Seychelles Rupee', value: 'SCR' },
  { text: 'Sudanese pound', value: 'SDG' },
  { text: 'Seele', value: 'SEELE' },
  { text: 'Swedish Krona', value: 'SEK' },
  { text: 'Singapore Dollar', value: 'SGD' },
  { text: 'St Helena Pound', value: 'SHP' },
  { text: 'SIT', value: 'SIT' },
  { text: 'SKK', value: 'SKK' },
  { text: 'Leone', value: 'SLL' },
  { text: 'Silverway', value: 'SLV' },
  { text: 'SML', value: 'SML' },
  { text: 'Status', value: 'SNT' },
  { text: 'Synthetix Network Token', value: 'SNX' },
  { text: 'SOLVE', value: 'SOLVE' },
  { text: 'Somali Shilling', value: 'SOS' },
  { text: 'Surinamese dollar', value: 'SRD' },
  { text: 'South Sudanese Pound', value: 'SSP' },
  { text: 'Dobra', value: 'STD' },
  { text: 'Steem', value: 'STEEM' },
  { text: 'Storj', value: 'STORJ' },
  { text: 'Stratis', value: 'STRAT' },
  { text: 'Blockstack', value: 'STX' },
  { text: 'SUR', value: 'SUR' },
  { text: 'SVC', value: 'SVC' },
  { text: 'Swipe', value: 'SXP' },
  { text: 'Syrian Pound', value: 'SYP' },
  { text: 'Syscoin', value: 'SYS' },
  { text: 'Lilangeni', value: 'SZL' },
  { text: 'Baht', value: 'THB' },
  { text: 'THETA', value: 'THETA' },
  { text: 'TJR', value: 'TJR' },
  { text: 'Tajikistani somoni', value: 'TJS' },
  { text: 'TMM', value: 'TMM' },
  { text: 'Turkmenistani manat', value: 'TMT' },
  { text: 'Tunisian Dinar', value: 'TND' },
  { text: 'Tierion', value: 'TNT' },
  { text: 'TomoChain', value: 'TOMO' },
  { text: "Pa'anga", value: 'TOP' },
  { text: 'Timorian Escudo', value: 'TPE' },
  { text: 'TRL', value: 'TRL' },
  { text: 'TRON', value: 'TRX' },
  { text: 'Turkish lira', value: 'TRY' },
  { text: 'Thunder Token', value: 'TT' },
  { text: 'Trinidad and Tobago Dollar', value: 'TTD' },
  { text: 'TrueUSD', value: 'TUSD' },
  { text: 'Taiwan Dollar', value: 'TWD' },
  { text: 'Tanzanian Shilling', value: 'TZS' },
  { text: 'Hryvna', value: 'UAH' },
  { text: 'UAK', value: 'UAK' },
  { text: 'UGS', value: 'UGS' },
  { text: 'Ugandan shilling', value: 'UGX' },
  { text: 'United States Dollar', value: 'USD' },
  { text: 'USD Coin', value: 'USDC' },
  { text: 'Tether', value: 'USDT' },
  { text: 'USN', value: 'USN' },
  { text: 'USS', value: 'USS' },
  { text: 'UYN', value: 'UYN' },
  {
    text: 'Uruguayan Peso, replaced by Uruguayan New Peso (UYU)',
    value: 'UYP',
  },
  { text: 'Uruguayan New Peso', value: 'UYU' },
  { text: 'Uzbekistani Som', value: 'UZS' },
  { text: 'VAL', value: 'VAL' },
  { text: 'VEB', value: 'VEB' },
  { text: 'Venezuelan bolívar fuerte', value: 'VEF' },
  { text: 'VeChain', value: 'VET' },
  { text: 'Viet Nam Dông', value: 'VND' },
  { text: 'V Systems', value: 'VSYS' },
  { text: 'Vertcoin', value: 'VTC' },
  { text: 'Vatu', value: 'VUV' },
  { text: 'Wanchain', value: 'WAN' },
  { text: 'Waves', value: 'WAVES' },
  { text: 'WAX', value: 'WAXP' },
  { text: 'WaykiChain', value: 'WICC' },
  { text: 'WINk', value: 'WIN' },
  { text: 'Tala', value: 'WST' },
  { text: 'Waltonchain', value: 'WTC' },
  { text: 'Wirex Token', value: 'WXT' },
  { text: 'Franc de la Communauté financière africaine', value: 'XAF' },
  { text: 'Silver (one troy ounce)', value: 'XAG' },
  { text: 'Gold', value: 'XAU' },
  { text: 'XBA', value: 'XBA' },
  { text: 'XBB', value: 'XBB' },
  { text: 'XBC', value: 'XBC' },
  { text: 'XBD', value: 'XBD' },
  { text: 'East Caribbean Dollar', value: 'XCD' },
  { text: 'NEM', value: 'XEM' },
  { text: 'XEU', value: 'XEU' },
  { text: 'XFO', value: 'XFO' },
  { text: 'UIC franc (special settlement currency)', value: 'XFU' },
  { text: 'Stellar', value: 'XLM' },
  { text: 'Monero', value: 'XMR' },
  { text: 'XMax', value: 'XMX' },
  { text: 'West African Franc', value: 'XOF' },
  { text: 'Palladium (one troy ounce)', value: 'XPD' },
  { text: 'Franc des Comptoirs français du Pacifique', value: 'XPF' },
  { text: 'Platinum (one troy ounce)', value: 'XPT' },
  { text: 'XRP', value: 'XRP' },
  { text: 'Code reserved for testing purposes', value: 'XTS' },
  { text: 'Tezos', value: 'XTZ' },
  { text: 'Verge', value: 'XVG' },
  { text: 'No currency', value: 'XXX' },
  { text: 'Zcoin', value: 'XZC' },
  { text: 'Yap Stone', value: 'YAP' },
  { text: 'YDD', value: 'YDD' },
  { text: 'Yemeni Riyal', value: 'YER' },
  { text: 'YOU COIN', value: 'YOU' },
  { text: 'YUD', value: 'YUD' },
  { text: 'YUG', value: 'YUG' },
  { text: 'YUM', value: 'YUM' },
  { text: 'YUN', value: 'YUN' },
  { text: 'YUO', value: 'YUO' },
  { text: 'YUR', value: 'YUR' },
  { text: 'ZAL', value: 'ZAL' },
  { text: 'Rand', value: 'ZAR' },
  { text: 'ZB Token', value: 'ZB' },
  { text: 'Zcash', value: 'ZEC' },
  { text: 'Horizen', value: 'ZEN' },
  { text: 'Zilliqa', value: 'ZIL' },
  { text: 'Zambian Kwacha', value: 'ZMW' },
  { text: 'ZRN', value: 'ZRN' },
  { text: '0x', value: 'ZRX' },
  { text: 'ZRZ', value: 'ZRZ' },
  { text: 'ZWC', value: 'ZWC' },
  { text: 'ZWD', value: 'ZWD' },
  { text: 'ZWN', value: 'ZWN' },
] as const;

export type CurrencyType = (typeof CURRENCY_CODE_OPTIONS)[number]['value'] | '';
